module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_PT-533597f3e353012933e719bf12df524f.svg";